import React, { useState, useEffect } from 'react';

const CorrectScanDialog = ({ quantity, setShowCorrectScanDialog, focusScanArea, switchUnpickable, dialogLineItemId }) => {
  useEffect(() => {
    let confirm = document.getElementById('confirm-button');
    confirm.focus();
  }, []);

  const close = () => {
    setShowCorrectScanDialog(false);
    focusScanArea();
  }

  const setUnpickable = () => {
    switchUnpickable(dialogLineItemId);
    close();
  }

  return(
    <div className="main-overlay main-overlay__success">
      <div style={{ top: `${window.innerHeight/2}px` }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => close()}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            <h2 className="success">Correct Item</h2>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 18">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6508 2.7408c.4193.3594.4679.9907.1085 1.41l-9 10.5c-.3791.4423-1.0545.4682-1.4664.0563l-5-5c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l4.2364 4.2364 8.2972-9.68c.3595-.4194.9908-.468 1.4101-.1085z"/>
              </svg>
              <span className="left-15">The scanned item is in this order. Please pick this quantity:</span>
            </div>
            <p className="pick-quantity">
              { quantity }
            </p>

            <br/>
            <button className="bottom-5 btn btn-default btn--destructive" onClick={() => setUnpickable()}>Could not pick</button>
            <button id="confirm-button" className="bottom-5 btn btn-primary btn-medium" onClick={() => close()}>Confirm</button>
          </div>
        </div>
      </div>
    </div>
  )

}

export default CorrectScanDialog;
